
import initTime from '~/plugins/initTime';
export default {
  filters: {
    getTime(value) {
      return initTime(value * 1000).format('Y-M-D H:m');
    },
  },
  props: {
    value: {
      // 绑定值
      type: [String, Object],
      default: '',
    },
    couponList: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    model: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },

  methods: {
    clickCoupon() {
      this.$emit('chooseCoupon');
    },
  },
};
